import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { FormControl } from '../../../../../facturotopia';
import ClaveRegimenAduanero from '../../../support/catalogs/complementos/cartaporte/ClaveRegimenAduanero';

class CartaPorteRegimenesAduanerosForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      isValid: false,
      validator: new Validator({}, this.rules({})),
    };
  }

  componentDidUpdate() {
    const { data } = this.props;

    if (!!data) {
      this.setState({
        data: {
          ...data,
        },
        isValid: true,
      });
    }
  }

  rules(data) {
    return {
      RegimenAduanero: ['required'],
    };
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value,
    };

    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes(),
    });
  };

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({ validator });

    return validator;
  }

  handleOnAdd = () => {
    const data = this.state.data;

    const newData = { ...data };

    this.props.onAdd(newData);

    this.setState({ isValid: false, data: {} });
  };

  handleOnClose = (values) => {
    this.setState({
      ...this.state.data,
      ...values,
    });
  };

  render() {
    const rules = this.rules();
    const { isValid, data = {} } = this.state;

    return (
      <>
        <Row>
          <Col
            sm
            md={4}
          >
            <FormControl
              type="select"
              label="Régimen Aduanero"
              name="RegimenAduanero"
              placeholder=""
              help=""
              rules={rules.RegimenAduanero}
              value={data.RegimenAduanero}
              options={ClaveRegimenAduanero}
              onChange={this.handleOnChange}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <p className="text-muted">
              Puedes agregar varios régimenes aduaneros usando el botón "Agregar régimen", la lista se mostrará en la
              tabla de régimenes.
            </p>
          </Col>
        </Row>

        <Row className="pt-3">
          <Col className="text-right">
            <Button
              variant="secondary"
              disabled={!isValid}
              onClick={this.handleOnAdd}
            >
              Agregar régimen
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}

export default CartaPorteRegimenesAduanerosForm;
